<template>
	<v-list-item
		style="border: 1px solid #e0e0e0; border-radius: 5px"
	>
		<v-list-item-icon class="mr-3">
			<v-icon color="primary">mdi-certificate-outline</v-icon>
		</v-list-item-icon>
		<v-list-item-content>
			<v-list-item-title>
				<strong>{{speciality.name}}</strong>
			</v-list-item-title>
			<v-list-item-subtitle></v-list-item-subtitle>
		</v-list-item-content>
		<v-list-item-action>
      <v-row no-gutters align="center">
        <!-- <v-btn icon @click="removeSpeciality">
          <v-icon color="primary">delete</v-icon>
        </v-btn> -->
        <v-btn icon @click="showEdit = true">
          <v-icon color="primary">mdi-pencil</v-icon>
        </v-btn>
      </v-row>
		</v-list-item-action>
    <v-dialog v-model="showEdit" :max-width="!consent ? '40%' : '70%'" scrollable>
			<v-card>
				<v-card-title class="title primary--text mb-2 secondary">
					<v-icon color="primary" class="mr-2">mdi-certificate-outline</v-icon>
					<translate>Edit Speciality</translate>
				</v-card-title>
				<v-card-text class="pt-2">
					<v-form ref="form">
						<v-row no-gutters>
              <v-col cols="12" v-if="!consent">
								<v-text-field
									v-model="speciality.name"
									:label="$gettext('Name')"
									outlined
									class="px-2"
									:rules="[required]"
								></v-text-field>
							</v-col>
              <template v-if="consent">
                <v-col cols="12" class="mb-3">
                  <h3 v-translate>Terapeutic Consent</h3>
                </v-col>
                <v-col cols="12">
                  <span v-translate class="font-weight-bold">Older</span>
                  <RichTextEditor class="mt-2" ref="editorOlder" :consent="true" :text="speciality.terapeutic_consent_text" />
                </v-col>
                <v-col cols="12" class="my-2">
                  <span v-translate class="font-weight-bold">Minor</span>
                  <RichTextEditor class="mt-2" ref="editorMinor" :consent="true" :isMinor="true" :text="speciality.terapeutic_consent_minor_text" />
                </v-col>
              </template>
						</v-row>
					</v-form>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-btn color="primary darken-1" text @click="showEdit = false">
						<translate key="close">Close</translate>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" text @click="editSpeciality" :loading="savingSpeciality">
						<translate key="save">Save</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-list-item>
</template>

<script>
import RichTextEditor from "@/components/RichTextEditor.vue";
import axios from "axios";

export default {
  name: "SpecialityItem",
  props: ["speciality", "consent"],
  components: {
    RichTextEditor
  },
  data: () => ({
    showEdit: false,
		savingSpeciality: false
  }),
  computed: {
    required() {
			return value => !!value || this.$gettext("Required.");
		}
  },
  methods: {
    editSpeciality() {
      if (this.$refs.form.validate()) {
				this.savingSpeciality = true;
        const form = new FormData();
        form.append("name", this.speciality.name);
        if(this.consent) {
          form.append("terapeutic_consent_text", this.$refs.editorOlder.getHTML());
          form.append("terapeutic_consent_minor_text", this.$refs.editorMinor.getHTML());
        }
				axios
					.post("/speciality/" + this.speciality.id + "/edit", form)
					.then(response => {
						console.log(response.data);
						if (response.data.result == "ok") {
							this.savingSpeciality = false;
							this.showEdit = false;
						}
					})
					.catch(error => console.log(error));
			}
    },
    removeSpeciality() {
			this.$emit("remove-speciality", this.speciality);
		}
  }
}
</script>